export type MediaCategory =
  | 'PRODUCT_THUMBNAIL'
  | 'PRODUCT_DETAIL'
  | 'CMS_BANNER'
  | 'CMS_POPUP'
  | 'CMS_EVENT'
  | 'CMS_NOTICE'
  | 'OFFLINE_STORE'
  | 'FUNDING_COVER'
  | 'MISC';

export interface PresignFileRequest {
  filename: string;
  contentType: string;
  sizeBytes: number;
  category: MediaCategory;
}

export interface PresignedItem {
  fileId: string;
  objectKey: string;
  uploadUrl: string;
  uploadMethod: 'PUT';
  requiredHeaders: Record<string, string>;
  publicUrl: string;
}

export interface ConfirmedItem {
  fileId: string;
  publicUrl: string;
  status: string;
}

export const ALLOWED_CONTENT_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
] as const;

export type AllowedContentType = (typeof ALLOWED_CONTENT_TYPES)[number];

export const MAX_FILE_BYTES = 10 * 1024 * 1024;
